import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';

const ValidationListItem = ({ isValid, children, ...props })=>{
    return jsxs("li", {
        ...props,
        children: [
            jsx(Icon, {
                className: classNames('icon', {
                    valid: isValid,
                    invalid: !isValid
                }),
                name: isValid ? 'CheckOutline' : 'XSolid',
                size: 20
            }),
            jsx("span", {
                className: classNames('label', {
                    valid: isValid,
                    invalid: !isValid
                }),
                children: children
            })
        ]
    });
};
ValidationListItem.displayName = 'ValidationList.Item';

export { ValidationListItem };
//# sourceMappingURL=ValidationList.Item.es.js.map
